export default "__VITE_ASSET__CyusDneP__"